<template>

  <div class="animated fadeIn">

    <b-card no-body>
      <b-card-body fluid="xl">

        <b-form @submit.stop.prevent="onSubmit">

          <b-row>
            <b-col>
              <b-form-group label="First Name" label-for="firstName" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="firstName"
                              :state="validateState('firstName')"
                              name="firstName"
                              aria-describedby="liveFeedbackName"
                              v-model.lazy.trim="$v.form.firstName.$model" />
                <b-form-invalid-feedback id="liveFeedbackName">
                  This is a required field.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Last Name" label-for="lastName" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="lastName"
                              :state="validateState('lastName')"
                              name="lastName"
                              aria-describedby="liveFeedbackLastName"
                              v-model.lazy.trim="$v.form.lastName.$model" />
                <b-form-invalid-feedback id="liveFeedbackLastName">
                  This is a required field.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Mobile Number" label-for="mobile" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="mobile"
                              :state="validateState('mobile')"
                              name="mobile"
                              aria-describedby="liveFeedbackmobile"
                              v-model.lazy.trim="$v.form.mobile.$model" />
                <b-form-invalid-feedback id="liveFeedbackmobile">
                  This is a required field.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Address" label-for="address" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="address"
                              :state="validateState('address')"
                              name="address"
                              aria-describedby="liveFeedbackAddress"
                              v-model.lazy.trim="$v.form.address.$model" />
                <b-form-invalid-feedback id="liveFeedbackAddress">
                  This is a required field.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="AadharCard No" label-for="aadharcard" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="aadharcard" name="aadharcard" v-model.lazy.trim="form.adharCardNumber" />

              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Vaccination Doses" label-for="treatments" label-cols-sm="4" label-cols-lg="3">
                <b-input-group id="treatments" name="treatments">
                  <b-input-group-prepend>
                    <b-button variant="outline-info" @click="removeTreatment">Remove Dose</b-button>
                  </b-input-group-prepend>
                  <b-form-input v-model="numberOfTreatments" disabled></b-form-input>
                  <b-input-group-append>
                    <b-button variant="success" @click="addTreatment">Add Dose</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group label="" label-for="" label-cols-sm="4" label-cols-lg="3">
                <treatment-list @doseAdded="setDoses" ref="treatmentList"></treatment-list>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-col cols="4">

              <b-button ref="submitButton" type="submit" variant="primary" :disabled="$v.form.$invalid">
                Save
              </b-button>
              <b-button class="ml-1" @click="onReset">Close</b-button>

            </b-col>

          </b-row>
        </b-form>
        <div id="vCardEdit" style="display:none;">
          <vaccination-print-card ref="vacPrintCardEdit"></vaccination-print-card>
        </div>
      </b-card-body>

    </b-card>
  </div>

</template>
<script>

  import { mapState, mapActions } from 'vuex'
  import Vue from 'vue'
  import { validationMixin } from "vuelidate";
  import { required, minLength,numeric, minValue, maxLength, email,alpha,helpers } from "vuelidate/lib/validators";

  import TreatmentList from './VaccinationList'
  import VaccinationPrintCard from './VaccinationPrintCard'
  const alpha_space = helpers.regex('alpha_space', /^[a-zA-Z\s]*$/)
  const formShape = {
    firstName: null,
    lastName: null,
    address: null,
    mobile: null,
    doses:{},
    id: null,
    adharCardNumber:null
  }

  export default {
    name: 'VimsEditPerson',
    props: {
      selectedPerson: Object
    },
    components: {
      TreatmentList,
      VaccinationPrintCard

    },
    data: function() {
      return {
        form: Object.assign({}, formShape),
        patients: [],
        numberOfTreatments: 0,
        showPrintCard: false,
        person:[],
        doses:[],

      }
    },
    validations: {
      form: {
        firstName: {
          required,
          alpha_space
        },
        lastName: {
          alpha_space
        },
        address: {
          required
        },
        mobile: {
          required,
          numeric,
          minLength : minLength(10),
          maxLength : maxLength(12)
        },
        doses: {
          required,
          $each: {
            vtype: {
              required,
            },
            dose: {
              required
            },
            date: {
              required
            }
          }
        }

      }
    },

    methods: {
      addTreatment() {
       if (this.numberOfTreatments < 2) {
         this.numberOfTreatments++;
         this.$refs.treatmentList.addTreatment()
       }
     },
     removeTreatment() {
       if (this.numberOfTreatments > 0) {
           this.numberOfTreatments--
         this.$refs.treatmentList.removeTreatment()
       }
     },
     createPatientModal(){

     },
     setDoses(param){
       this.form.doses = param;
     },
     validateState(name) {
       const { $dirty, $error } = this.$v.form[name];
       return $dirty ? !$error : null;
     },
     isValid() {
       this.$v.$touch();
       return !this.$v.form.$anyError
     },
     onSubmit(evt){

       console.log(JSON.stringify(this.form, null, 4));
       if(this.isValid){
         this.submitted = true;
         this.$refs.submitButton.disabled = true;
         this.$nextTick(() => {
           let params = JSON.stringify(this.form);
           this.$store.dispatch('vims/updateVimsEntry', params)
             .then((response) => {
               if(response.data.success == false){
                   this.showErrorMsg({
                     message: response.data.error
                   });
                   this.$refs.submitButton.disabled = false;
               }
               else{
                       this.showSuccessMsg({
                         message: 'Record Updated successfully.'
                       });
                       this.showPrintCard = false;
                       this.setVacCardData(response.data.data);


               }
             })
             .catch((error) => {
               if (error.response.status == 400) {
                 this.showErrorMsg({
                   message: error.response.data.message
                 })
               }
               else if (error.response.status == 422){
                   this.showErrorMsg({
                     message: error.response.data.message
                   });
                   this.showDismissibleAlert=true;
                   var errors = Object.values(error.response.data.errors);
                   this.submissionErros = errors;

               }
               else {
                 this.showErrorMsg()
               }
               this.$refs.submitButton.disabled = false;
             })


         });
       }
     },
     async setVacCardData(data){
       let person = [];
       let doses = [];
       person['srNo'] = data.srNo;
       person['name'] = data.name;
       person['mobile'] = data.mobile;
       person['cardNo'] = data.cardNo;
       person['address'] = data.address;
       doses = data.doses;
       this.$refs.vacPrintCardEdit.setCardData(person,doses);
       await this.sleep(1000);
       this.$htmlToPaper('vCardEdit');
       this.onReset();


     },

     sleep(ms) {
       return new Promise((resolve) => {
         setTimeout(resolve, ms);
      });
    },
     onReset() {
       // Reset validation
       this.form = Object.assign({}, formShape);
       this.numberOfTreatments = 0;
       this.$refs.treatmentList.onReset();
       this.$refs.vacPrintCardEdit.resetData();
       this.submitted = false;
       this.$nextTick(() => {
         this.$v.$reset()
       })
       this.$emit('success')
     },
    },
    created() {
        this.form.firstName = this.selectedPerson.firstName;
        this.form.lastName = this.selectedPerson.lastName;
        this.form.address = this.selectedPerson.address;
        this.form.mobile = this.selectedPerson.mobile;
        this.form.id = this.selectedPerson.id;
        this.form.adharCardNumber = this.selectedPerson.adharCardNumber;
        this.numberOfTreatments = this.selectedPerson.doses;
        this.$nextTick(() => {
          let params = {
            id : this.form.id
          }
          this.$store.dispatch('vims/getPersonVacs', params)
            .then((response) => {
                  if (response.data.success == false) {
                    this.showErrorMsg({
                      message: response.data.error
                    })
                    this.$emit('cancel')
                  } else {
                    this.form.doses = response.data.data;
                    this.$refs.treatmentList.onReset();
                    this.form.doses.forEach((element, index, array) => {
                      this.$refs.treatmentList.setTreatment(element);
                    });
                  }
             })
            .catch((error) => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else if (error.response.status == 422) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg({ message: 'Something went when wrong getting Person Vaccination information. Please contact administrator.' })
              }
              this.$emit('cancel')
            })

        });

    }


  }

</script>
